/**
 * THE EMPTY CHAT'S FIRST SUGGESTIONS follow what the business does (round 2, as the portal's lunaStarters — owner
 * 10-22: "make sure it's aligned with the biz context"). A business that books offers a booking, stays a stay, courses
 * its courses, a shop a gift — never what it does not do — and every business the way there. At most four.
 *
 * The flags are the store's salon payload: `appointmentsEnabled` (on unless false, as the rest of the store reads it),
 * `productsEnabled`, `hospitalityEnabled`. `coursesEnabled` is read only when it is exactly true: the store's salon
 * payload does not carry it today, so the courses line stays off until it does.
 */
const STARTERS = {
  book: { key: 'agent.suggestBook', defaultValue: 'I want to book an appointment' },
  stay: { key: 'agent.suggestStay', defaultValue: 'I’d like to book a stay' },
  courses: { key: 'agent.suggestCourses', defaultValue: 'Which courses do you offer?' },
  gift: { key: 'agent.suggestGift', defaultValue: 'Help me find a gift' },
  where: { key: 'agent.suggestWhere', defaultValue: 'Where are you?' },
};

export function agentStarters(salon, t) {
  const s = salon || {};
  const picks = [];
  if (s.appointmentsEnabled !== false) picks.push(STARTERS.book);
  if (s.hospitalityEnabled === true) picks.push(STARTERS.stay);
  if (s.coursesEnabled === true) picks.push(STARTERS.courses);
  if (s.productsEnabled === true) picks.push(STARTERS.gift);
  const chosen = [...picks.slice(0, 3), STARTERS.where];
  return chosen.map(({ key, defaultValue }) => ({ key, label: t(key, { defaultValue }) }));
}
